module.exports = __webpack_public_path__ + "media/images/pillar_ads-4845f331f56a8f292ee16c1a83f5f550.jpg";